import React from "react";

export default function QuestionnaireCompletionTimeBySurvey({ questionnaires }) {

    /* =========================
       Helpers
       ========================= */

    function safeNumber(v) {
        return typeof v === "number" && !isNaN(v) ? v : 0;
    }

    function getDelta(trendValues) {
        if (!trendValues || trendValues.length < 2) return 0;
        const last = trendValues[trendValues.length - 1];
        const prev = trendValues[trendValues.length - 2];
        return Math.round((last - prev) * 10) / 10;
    }

    /* =========================
       Styles (unchanged)
       ========================= */

    const styles = {

        container: {
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            padding: "10px 6px"
        },

        row: {
            display: "flex",
            alignItems: "center",
            gap: "10px"
        },

        label: {
            width: "200px",
            fontSize: "12px",
            fontWeight: 500,
            color: "#333",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis"
        },

        barTrack: {
            flex: 1,
            height: "10px",
            backgroundColor: "#eee",
            borderRadius: "5px",
            overflow: "hidden"
        },

        barFill: {
            height: "100%",
            backgroundColor: "#4c9aff",
            borderRadius: "5px"
        },

        deltaPositive: {
            fontSize: "12px",
            fontWeight: 600,
            color: "#2e7d32",
            minWidth: "48px",
            textAlign: "right"
        },

        deltaNegative: {
            fontSize: "12px",
            fontWeight: 600,
            color: "#c62828",
            minWidth: "48px",
            textAlign: "right"
        },

        trend: {
            display: "flex",
            alignItems: "flex-end",
            height: "18px",
            gap: "2px",
            minWidth: "36px"
        },

        trendBar: {
            width: "4px",
            backgroundColor: "#bbb",
            borderRadius: "2px"
        },

        trendBarLast: {
            backgroundColor: "#4c9aff"
        }
    };

    /* =========================
       Render
       ========================= */

    if (!Array.isArray(questionnaires) || questionnaires.length === 0) {
        return null;
    }

    // find max avg minutes for scaling bars
    const maxMinutes = Math.max(
        ...questionnaires.map(q => safeNumber(q.averageCompletionMinutes)),
        1
    );

    return (
        <div style={styles.container}>

            {questionnaires.map(function (q) {

                const avgMinutes = safeNumber(q.averageCompletionMinutes);

                const trendValues = Array.isArray(q.completionTimeTrend)
                    ? q.completionTimeTrend.map(t => safeNumber(t.value))
                    : [];

                const delta = getDelta(trendValues);

                const displayTrend =
                    trendValues.length > 0
                        ? trendValues.slice(-6)
                        : [];

                const barWidthPercent =
                    Math.round((avgMinutes / maxMinutes) * 100);

                return (
                    <div key={q.questionnaireId} style={styles.row}>

                        {/* Label */}
                        <div style={styles.label} title={q.title}>
                            {q.title}
                        </div>

                        {/* Bar */}
                        <div style={styles.barTrack}>
                            <div
                                style={{
                                    ...styles.barFill,
                                    width: barWidthPercent + "%"
                                }}
                                title={avgMinutes + " minutes"}
                            />
                        </div>

                        {/* Delta */}
                        <div style={delta >= 0 ? styles.deltaPositive : styles.deltaNegative}>
                            {delta >= 0 ? "+" : ""}{delta}m
                        </div>

                        {/* Trend Bullet */}
                        <div style={styles.trend}>
                            {displayTrend.map(function (v, i) {
                                return (
                                    <div
                                        key={i}
                                        title={v + "m"}
                                        style={{
                                            ...styles.trendBar,
                                            height: Math.max(4, Math.min(18, v / 3)) + "px",
                                            ...(i === displayTrend.length - 1
                                                ? styles.trendBarLast
                                                : {})
                                        }}
                                    />
                                );
                            })}
                        </div>

                    </div>
                );
            })}

        </div>
    );
}
